import { Box } from '@mui/material';
import type { BoxProps } from '@mui/system';
import { type Editor, EditorContent } from '@tiptap/react';
import { handleDrop } from '@tyro/core';

interface MailEditorProps {
  editor: Editor | null;
  sx?: BoxProps['sx'];
}

export function MailEditor({ editor, sx }: MailEditorProps) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        my: 2,
        mx: 3,

        '.tiptap': {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,

          '&:focus': {
            outline: 'none',
          },

          '& p': {
            margin: 0,
            '&.is-editor-empty:first-child::before': {
              color: 'text.disabled',
              content: 'attr(data-placeholder)',
              float: 'left',
              height: 0,
              pointerEvents: 'none',
            },
          },
          ' & a': {
            color: 'primary.main',
          },
        },
        ...sx,
      }}
      onDrop={(e) => {
        if (editor) handleDrop(e, editor);
      }}
      component={EditorContent}
      editor={editor}
    />
  );
}
